import React from 'react';

export default function ReferenceLabel(props) {
    const {
        fill, value, textAnchor,
        fontSize, viewBox, dy, dx,
    } = props;
    let x = viewBox.width + viewBox.x - 30;
    if (x < 40) x = 40
    const y = viewBox.y - 3;
    return (
        <text
            x={x} y={y}
            dy={dy}
            dx={dx}
            fill={fill}
            fontSize={fontSize || 10}
            textAnchor={textAnchor}>
            {value}
        </text>
    )
}
